export const STRING_VALIDATION_PROPERTIES = [
  'maxLength',
  'minLength',
  'pattern',
  'format',
  'enum',
];

export const NUMBER_VALIDATION_PROPERTIES = [
  'maximum',
  'minimum',
  'multipleOf',
  'enum',
];

export const INTEGER_VALIDATION_PROPERTIES = [
  'maximum',
  'minimum',
  'multipleOf',
  'enum',
];

export const BOOLEAN_VALIDATION_PROPERTIES = ['enum'];

const validationPropertiesSet = new Set([
  ...STRING_VALIDATION_PROPERTIES,
  ...NUMBER_VALIDATION_PROPERTIES,
  ...INTEGER_VALIDATION_PROPERTIES,
  ...BOOLEAN_VALIDATION_PROPERTIES,
]);

export const isSchemaValidationProperty = (keyword: string) => {
  return validationPropertiesSet.has(keyword);
};
